/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RecentTickets.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";

// MUI components
import {
  Box,
  Button,
  Chip,
  FormControl,
  MenuItem,
  Select,
  Slide,
  Typography,
  styled,
  Tooltip,
} from "@mui/material";

// MUI icons

// Custom components

import CustomDataGridV2 from "../../../common/datagrid/CustomDataGridV2";

// Redux actions and APIs
import {
  HandleApiActions,
  labCar,
  userManagementApis,
} from "../../../../../redux/actions";
import typeApprovalAPI from "../../../../../redux/actions/typeApprovalAPI";
// Utils and constants
import {
  ConvertUTCToDate,
} from "../../../../../utils/convertUtcToTimeZone";
import CustomButtonV2 from "../../../common/button/CustomButtonV2";
import CustomDialogBoxV2 from "../../../common/customDialogBox/CustomDialogBoxV2";
import { TICKETS_TYPES } from "../../../../../config/appConstants";
import ModuleViewMoreDialog from "./ModuleViewMoreDialog";
import softwareIntersectionAPI from "../../../../../redux/actions/softwareIntersectionActions";
import { componentStyle } from "../../../../../config/appTheme";
import { useNavigate } from "react-router-dom";
import CustomToolTip from "../../../../infoButton/CustomToolTip";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ticketStatusNames = {
  101: "Draft",
  100: "New",
  150: "Confirm Legal Requirements",
  200: "Artifact Confirmation",
  300: "Evidence Submission",
  400: "Evidence Review",
  500: "Testing at TA reviewers",
  600: "Resolved",
  999: "Closed Incomplete",
};

const TICKET_COLUMNS = [
  {
    field: "intr_id",
    headerName: "INTERSECTION edited ID",
    headerAlign: "center",
    width: 140,
    renderCell: (params) => (
      <Box sx={{ textAlign: "center", fontSize: "12px" }}>
        {params?.value || "-"}
      </Box>
    ),
  },
];

function RecentTickets({
  tickets_type = TICKETS_TYPES.EE,
  ticketDetails,
  hasTicketNeedMore,
}) {
  // Styles
  const LinkButton = styled(Button)(({ theme }) => ({
    textTransform: "none",
    color: theme.palette.primary.main,
    textDecoration: "underline",
    padding: 0,
    minWidth: "auto",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  }));

  const CountdownTimer = styled(Typography)(({ theme }) => ({
    backgroundColor: "green",
    color: "white",
    borderRadius: 0,
    textAlign: "center",
    width: "100px",
    cursor: "pointer",
  }));
  // hooks
  const dispatch = useDispatch();
  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );
  const profileDetails = useSelector((store) => store.profileReducer);
  const navigate = useNavigate();

  // states
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedVarientId, setSelectedVarientId] = useState(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [linkApiProps, setLinkApiProps] = useState(null);
  const [page] = useState(1);
  const [rowsPerPage] = useState(25);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(5);
  const [intervalId, setIntervalId] = useState(null);
  const [userDetailsMap, setUserDetailsMap] = useState(new Map());
  const [dialogData, setDialogData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [eeDialogData, setEEDialogData] = useState(null);
  const [legalDialogData, setLegalDialogData] = useState(null);
  const [isLegalDialogOpen, setIsLegalDialogOpen] = useState(false);
  const [selectedTableRowData, setSelectedTableRowData] = useState(null);
  const [isAddTestArtifactsDialogOpen, setIsAddTestArtifactsDialogOpen] =
    useState(false);
  const [isViewTestArtifactsDialogOpen, setIsViewTestArtifactsDialogOpen] =
    useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [dynamicFormData, setDynamicFormData] = useState(null);
  const [isTemplateDialogOpen, setIsTemplateDialogOpen] = useState(false);
  const [isViewTraceTrackDialogOpen, setIsViewTraceTrackDialogOpen] =
    useState(false);
  const [isEEDialogOpen, setIsEEDialogOpen] = useState(false);
  const [tableRowsData, setTableRowsData] = useState([]);
  const [apiAction, setApiAction] = useState("");
  const [apiDataKey, setApiDataKey] = useState("");
  const [moduleViewMoreType, setModuleViewMoreType] = useState("");
  const [usersDetail, setUsersDetail] = useState(new Map());
  // Const
  const roleType = profileDetails?.profile?.role_details?.role_type;
  const supplier = roleType === 2;
  const ticketStatus = {
    100: (
      <Chip
        sx={{
          fontWeight: "bold",

          background: "none",
          color: "#000000",
          fontSize: "12px",
        }}
        label={"NEW"}
        size="medium"
      />
    ),
    101: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"DRAFT"}
        size="medium"
      />
    ),
    150: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"CONFIRM LEGAL REQUIREMENTS"}
        size="medium"
      />
    ),
    200: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"ARTIFACT CONFIRMATION"}
        size="medium"
      />
    ),
    300: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"EVIDENCE SUBMISSION"}
        size="medium"
      />
    ),
    400: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"EVIDENCE REVIEW"}
        size="medium"
      />
    ),
    500: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#0076a8",
          fontSize: "12px",
        }}
        label={"TESTING AT TA reviewers"}
        size="medium"
      />
    ),
    600: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#26890D",
          fontSize: "12px",
        }}
        label={"RESOLVED"}
        size="medium"
      />
    ),
    999: (
      <Chip
        sx={{
          fontWeight: "bold",
          background: "none",
          color: "#26890D",
          fontSize: "12px",
        }}
        label={"CANCELLED"}
        size="medium"
      />
    ),
  };

  const handleClickOpen = (ticket_id) => {
    setCurrentTicketId(ticket_id);
    setOpen(true);
    setTimer(5);
  };

  const handleClose = () => {
    setOpen(false);
    if (intervalId) {
      clearInterval(intervalId);
    }
  };

  const handleRedirect = () => {
    setOpen(false);
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
    if (currentTicketId) {
      const linkType = currentTicketId.startsWith("INC")
        ? "incident.do"
        : "sn_customerservice_case.do";
      window.open(
        `https://ven07074.service-now.com/${linkType}?sysparm_query=number=${currentTicketId}`,
        "_blank",
      );
    }
  };

  const getTicketStatusName = (statusCode) => {
    return ticketStatus[statusCode] || "-";
  };
  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Toggles the dialog open/closed state
   * @param {boolean} newOpen - True to open the dialog, false to close it
   */
  /*******  d8721e2c-0bfc-46ab-8b2b-5145cbf9e9eb  *******/
  const toggleDialog = (newOpen) => () => {
    setIsEEDialogOpen(newOpen);
  };

  const handleSWMViewButtonClick = (item) => {
    const modules = item?.dependencies?.software_modules || [];
    const vehicleFunctions = item?.swm_details?.vehicle_functions;
    setSelectedComponent(item);
    setApiAction(softwareIntersectionAPI.get_software_intersections);
    setLinkApiProps({
      swm_id: item?.swm_details?.swm_id,
      ee_id: item?.ee_details?.ee_id,
    });
    setApiDataKey("linked_swm_details");
    setModuleViewMoreType("SWM");

    // Map the modules to include both module details and their corresponding ee_details
    const items2 = modules?.map((module) => ({
      swm_id: module?.swm_id,
      name: module?.name,
      version: module?.version,
      description: module?.description,
      ee_details: module?.ee_details || [], // Include ee_details in each module
    }));

    const eeDetails = modules.flatMap((module) => module?.ee_details) || [];

    setDialogData({
      heading1: `Vehicle Functions`,
      items1:
        vehicleFunctions?.map((vehicleFunction) => ({
          name: vehicleFunction?.name,
          abbreviation: vehicleFunction?.abbreviation,
        })) || [],
      heading2: `Dependent Software Modules`,
      items2: items2, // Use the combined items
      heading3: `EE Details`,
      items3: eeDetails?.map((ee) => ({
        ee_id: ee?.ee_id,
        assembly_number: ee?.assembly_number,
        description: ee?.description,
        supplier_name: ee?.supplier_name,
        version: ee?.version,
      })),
    });

    toggleDialog(true)();
  };

  const handleEEViewButtonClick = (item) => {
    const modules = item?.dependencies?.ee_components || [];
    const vehicleSystems = item?.ee_details?.vehicle_systems;

    setSelectedComponent(item);
    setApiAction(labCar.get_ee_intersections);
    setLinkApiProps({
      ee_id: item?.ee_details?.ee_id,
    });
    setApiDataKey("linked_ee_details");
    setModuleViewMoreType("EE");
    setEEDialogData({
      heading1: `Vehicle Systems`,
      items1:
        vehicleSystems?.map((vs) => ({
          name: vs?.name,
          abbreviation: vs?.abbreviation,
        })) || [],
      heading2: `Dependent EE Components`,
      items2: modules?.map((ee) => ({
        ee_id: ee?.ee_id,
        assembly_number: ee?.assembly_number,
        description: ee?.description,
        supplier_name: ee?.supplier_name,
        version: ee?.version,
      })),
    });

    toggleEEDialog(true)();
  };

  // VS View More handler — mirrors TicketsTable
  const handleVSViewButtonClick = (item) => {
    setSelectedComponent(item);
    setApiAction(labCar.get_vehicle_systems);
    setLinkApiProps({
      vs_id: item?.vehicle_system_details?.id,
    });
    setApiDataKey("linked_vs_details");
    setModuleViewMoreType("VS");
    toggleEEDialog(true)();
  };

  // VC View More handler — mirrors TicketsTable
  const handleVCViewButtonClick = (item) => {
    setSelectedComponent(item);
    setApiAction(labCar.get_vehicle_components);
    setLinkApiProps({
      vc_id: item?.vehicle_component_details?.id,
      vs_id: item?.vehicle_system_details?.id,
    });
    setApiDataKey("linked_vc_details");
    setModuleViewMoreType("VC");
    toggleEEDialog(true)();
  };

  const toggleLegalDialog = (newOpen) => () => {
    setIsLegalDialogOpen(newOpen);
  };
  const handleLEGALViewButtonClick = (item) => {
    const lr_details = item?.lr_details || {};
    const ls_details = item?.ls_details || {};

    // Directly map lr_details to items2
    const items2 = [
      {
        lr_id: lr_details.lr_id,
        chapter: lr_details.chapter,
        description: lr_details.description,
        req_number: lr_details.req_number,
      },
    ];

    // Create items3 from ls_details
    const items3 = [
      {
        ls_id: ls_details.ls_id,
        standard_number: ls_details.standard_number,
        name: ls_details.name,
        revision: ls_details.revision,
        description: ls_details.description,
        chapters: ls_details.chapters,
      },
    ];

    setLegalDialogData({
      heading2: `Legal Requirement`,
      items2: items2,
      items3: items3, // Optionally include ls_details if needed
    });

    toggleLegalDialog(true)();
  };

  const DescriptionCell = ({ value }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const maxLength = 200;
    // Function to toggle the description view
    const handleToggle = () => {
      setIsExpanded(!isExpanded);
    };
    const displayText =
      isExpanded || !value || value.length <= maxLength
        ? value
        : `${value.substring(0, maxLength)}...`;
    return (
      <Box sx={{ textAlign: "justify" }}>
        <Typography variant="body2">
          {displayText || "No Description for the selected project"}
          {value && value.length > maxLength && (
            <Button onClick={handleToggle} sx={{ textTransform: "none", p: 0 }}>
              {isExpanded ? "Show Less" : "Show More"}
            </Button>
          )}
        </Typography>
      </Box>
    );
  };

  const getTicketsTemplates = async ({ intrId }) => {
    const apiDetails = typeApprovalAPI.get_user_dynamic_forms;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          project_id: Number(selectedProject?.project_id),
          variant_id: Number(selectedVariant?.variant_id),
          intr_id: intrId,
          page_number: 1,
          page_size: 100,
          is_ticket_required: true,
        },
      }),
    );
    if (resp.error) {
      setDynamicFormData([]);
    } else {
      setDynamicFormData(resp?.data?.[0]);
    }
  };

  const toggleEEDialog = (newOpen) => () => {
    setIsEEDialogOpen(newOpen);
  };

  const fetchUserDetails = async () => {
    try {
      const apiDetails = userManagementApis?.get_users_list_pa;
      delete apiDetails.action_type;
      const resp = await dispatch(
        HandleApiActions({
          ...apiDetails,
          params: {
            page_size: 10000,
            page_number: 1,
          },
          show_toast: false,
        }),
      );

      if (!resp.error) {
        const users = resp?.data || [];
        const userMap = new Map(users?.map((user) => [user?.user_id, user]));
        setUserDetailsMap(userMap);
        setUsersDetail(users);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (!open) return; // Prevent interval from creating when dialog is closed.

    setTimer(5); // Reset timer here so it’s set BEFORE interval starts.

    const id = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(id);
    };
  }, [open]);

  // column
  const COLUMNS = [
    {
      field: "ticket_id",
      headerName: "Ticket Details",
      headerAlign: "center",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const ee_details = params?.row?.ee_details || {};

        const renderDetails = (label, details) => (
          <Box
            sx={{
              marginBottom: "8px",
              p: 0,
              height: "100%",
            }}
          >
            <Box sx={{ fontWeight: "bold", mb: 1 }}>{label}</Box>
            {Object.entries(details).map(([key, value]) => (
              <Box
                key={key}
                sx={{
                  ...componentStyle.font.tableText,
                  display: "flex",
                  gap: 0.5,
                }}
              >
                {key.replace(/_/g, " ")}:{" "}
                <CustomToolTip
                  length={12}
                  style={{ ...componentStyle.font.tableText }}
                >
                  {value || "-"}
                </CustomToolTip>
              </Box>
            ))}
          </Box>
        );

        return (
          <Box
            sx={{
              textAlign: "left",
              ...componentStyle.font.tableText,

              p: 0,
              m: "-8px 0",
              minWidth: "100%",
            }}
          >
            {renderDetails("", {
              "Ticket Id": params?.value ? (
                <LinkButton
                  sx={{ ...componentStyle.font.tableText, mt: -0.5 }}
                  onClick={() => handleClickOpen(params.value)}
                >
                  {params?.value}
                </LinkButton>
              ) : (
                "-"
              ),
              "Intersection Id": params?.row?.intr_id || "-",
              Status: ticketStatusNames[params?.row?.status],
              "Created By":
                userDetailsMap?.get(params?.row?.created_by)?.fullname || "-",
              "Updated By": params?.row?.updated_user_details?.[0]?.name,
              Description: params?.row?.description,
              Reason: params?.row?.reason,
            })}

            <CustomDialogBoxV2
              open={open}
              onClose={handleClose}
              title={<Box></Box>}
            >
              <Box
                sx={{
                  width: "400px",
                  p: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ ...componentStyle.font.tabLevelHeader }}
                >
                  Redirecting to ServiceNow Ticketing tool!
                </Typography>

                <CountdownTimer
                  onClick={handleRedirect}
                  sx={{
                    width: "fit-content",
                    mt: 1,
                    px: 2,
                    ...componentStyle.font.tabLevelHeader,
                    fontWeight: 500,
                  }}
                >
                  Redirecting in ({timer}) sec..
                </CountdownTimer>
              </Box>
            </CustomDialogBoxV2>
          </Box>
        );
      },
    },
    {
      ...(
        Number(tickets_type) === TICKETS_TYPES.VEHICLE_SYSTEM ||
          Number(tickets_type) === TICKETS_TYPES.VEHICLE_COMPONENT
          ? {
            // Vehicle System column with View More — mirrors TicketsTable
            field: "vehicle_system_details",
            headerName: "Vehicle System",
            headerAlign: "left",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
              const { vehicle_system_details } = params?.row;
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    width: "100%",
                  }}
                >
                  <Box sx={{ textAlign: "left", fontSize: "14px" }}>
                    <Box sx={{ ...componentStyle.font.tableText }}>
                      Name: {vehicle_system_details?.name || "-"}
                    </Box>
                    <Box sx={{ ...componentStyle.font.tableText }}>
                      Assembly Number:{" "}
                      {vehicle_system_details?.assembly_number || "-"}
                    </Box>
                    <Box sx={{ ...componentStyle.font.tableText }}>
                      Description: {vehicle_system_details?.description || "-"}
                    </Box>
                  </Box>
                  {!supplier && (
                    <Box sx={{ textAlign: "left", marginTop: 2 }}>
                      <CustomButtonV2
                        handleOnClick={() => {
                          handleVSViewButtonClick(params?.row?.allData);
                        }}
                        size="small"
                        btnName={"View More..."}
                      />
                    </Box>
                  )}
                </Box>
              );
            },
          }
          : {
            field: "tickets_type",
            headerName: "Module Type",
            headerAlign: "left",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
              const { swm_details, ee_details } = params?.row;

              const vehicle_component_details = [
                params?.row?.vehicle_component_details,
              ];

              const renderDetails = (label, details) => (
                <Box
                  sx={{ height: "90px", minHeight: "90px", overflowY: "auto" }}
                >
                  <Box
                    sx={{
                      marginBottom: "8px",
                      ...componentStyle.font.tableText,
                    }}
                  >
                    {label}
                  </Box>
                  {Object.entries(details)?.map(([key, value]) => (
                    <Box key={key} sx={{ ...componentStyle.font.tableText }}>
                      {key.replace(/_/g, " ")}: {value || "-"}
                    </Box>
                  ))}
                </Box>
              );

              return (
                <Box
                  sx={{
                    textAlign: "left",
                    ...componentStyle.font.tableText,
                  }}
                >
                  {swm_details &&
                    Object.keys(swm_details).length > 0 &&
                    Number(params?.row?.ticket_type) === 1 ? (
                    <>
                      {renderDetails("Software Module", {
                        Number: swm_details?.name,
                        Version: swm_details?.version,
                        Description: swm_details?.description,
                      })}
                      {swm_details?.name && !supplier && (
                        <Box sx={{ textAlign: "left", marginTop: 2 }}>
                          <CustomButtonV2
                            handleOnClick={() => {
                              handleSWMViewButtonClick(params?.row?.allData);
                            }}
                            size="small"
                            btnName={"View More..."}
                          />
                        </Box>
                      )}
                    </>
                  ) : ee_details &&
                    Object.keys(ee_details).length > 0 &&
                    Number(params?.row?.ticket_type) === 2 ? (
                    <>
                      {renderDetails("EE Components", {
                        "Supplier Name": ee_details?.supplier_name,
                        "Assembly Number": ee_details?.assembly_number,
                        Version: ee_details?.version,
                        Description: ee_details?.description,
                      })}
                      {params?.row?.allData?.dependencies?.ee_components &&
                        !supplier && (
                          <Box sx={{ textAlign: "left", marginTop: 2 }}>
                            <CustomButtonV2
                              handleOnClick={(event) => {
                                handleEEViewButtonClick(params?.row?.allData);
                              }}
                              size="small"
                              btnName={"View More..."}
                            />
                          </Box>
                        )}
                    </>
                  ) : vehicle_component_details &&
                    vehicle_component_details.length > 0 ? (
                    <>
                      <Select
                        value={vehicle_component_details}
                        displayEmpty
                        sx={{ height: "40px", fontSize: "15px" }}
                        renderValue={(selected) => {
                          const selectedComponent =
                            vehicle_component_details.find(
                              (component) => component.id === selected,
                            );
                          return selectedComponent
                            ? `${selectedComponent.component} - ${selectedComponent.assembly_number}`
                            : "Vehicle Component";
                        }}
                      >
                        {vehicle_component_details?.map((component) => (
                          <MenuItem
                            sx={{
                              fontSize: "15px",
                              display: "block",
                              padding: "10px 15px",
                            }}
                            key={`vehicle-${component.id}`}
                            value={component.id}
                          >
                            <Box sx={{ marginBottom: "4px" }}>
                              <strong>Component:</strong> {component.component}
                            </Box>
                            <Box sx={{ marginBottom: "4px" }}>
                              <strong>Assembly No:</strong>{" "}
                              {component.assembly_number}
                            </Box>
                            <Box>
                              <strong>Summary:</strong> {component.summary}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </>
                  ) : (
                    <Box sx={{ color: "gray" }}>No Data Available</Box>
                  )}
                </Box>
              );
            },
          }
      ),
    },
    // Vehicle Component column — only for VEHICLE_COMPONENT tickets, mirrors TicketsTable
    ...(Number(tickets_type) === TICKETS_TYPES.VEHICLE_COMPONENT
      ? [
        {
          field: "vehicle_component_details",
          headerName: "Vehicle Component",
          headerAlign: "left",
          minWidth: 200,
          flex: 1,
          renderCell: (params) => {
            const { vehicle_component_details } = params?.row;
            return (
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1 }}
              >
                <Box
                  sx={{ textAlign: "left", ...componentStyle.font.tableText }}
                >
                  <Box>Name: {vehicle_component_details?.name || "-"}</Box>
                  <Box>
                    Component:{" "}
                    {vehicle_component_details?.component_number || "-"}
                  </Box>
                  <Box>
                    Description:{" "}
                    {vehicle_component_details?.description || "-"}
                  </Box>
                </Box>
                {!supplier && (
                  <Box sx={{ textAlign: "left", marginTop: 4 }}>
                    <CustomButtonV2
                      handleOnClick={() => {
                        handleVCViewButtonClick(params?.row?.allData);
                      }}
                      size="small"
                      btnName={"View More..."}
                    />
                  </Box>
                )}
              </Box>
            );
          },
        },
      ]
      : []),

    {
      field: "ls_lr_details",
      headerName: "Legal Details",
      headerAlign: "left",
      minWidth: 200,
      flex: 1,

      renderCell: (params) => {
        const { lr_details, ls_details } = params?.row;
        return (
          <Box sx={{ textAlign: "left", ...componentStyle.font.tableText }}>
            <Box sx={{ height: "90px", minHeight: "90px", overflowY: "auto" }}>
              <Box>Chapter: {lr_details?.chapter || "-"}</Box>
              <Box>Requirement Number: {lr_details?.req_number || "-"}</Box>
              <Box>Standard Number: {ls_details?.standard_number || "-"}</Box>
              <Box>Revision: {ls_details?.revision || "-"}</Box>
            </Box>

            <Box sx={{ textAlign: "left", marginTop: 2 }}>
              <CustomButtonV2
                handleOnClick={() => {
                  handleLEGALViewButtonClick(params?.row?.allData);
                }}
                size="small"
                btnName={"View More..."}
              />
            </Box>
          </Box>
        );
      },
    },
    {
      field: "test_case_details",
      headerName: "Test Case Details",
      headerAlign: "left",
      width: 180,
      renderCell: (params) => {
        const testCaseDetails = params?.row?.test_case_details ?? [];
        const hasTestCases = testCaseDetails.length > 0;

        return (
          <Box sx={{ width: "100%", borderRadius: "0px" }}>
            <Box sx={{ width: "100%", paddingTop: "40px" }}>
              <FormControl
                sx={{
                  ...componentStyle.form.select.formControl,
                  width: "160px",
                }}
              >
                <Select
                  size="small"
                  value=""
                  displayEmpty
                  fullWidth
                  renderValue={() =>
                    hasTestCases ? "View Test Cases" : "No Test Cases"
                  }
                  sx={{ ...componentStyle.form.select.select }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        width: "160px",
                      },
                      sx: { maxHeight: 300 },
                    },
                  }}
                >
                  {testCaseDetails.map((testCase) => (
                    <MenuItem
                      key={testCase.manual_test_case_id}
                      value={testCase.manual_test_case_id}
                      sx={{ ...componentStyle.form.select.menuItem }}
                    >
                      <Box
                        sx={{
                          p: 0,
                          m: 0,
                          width: "100%",
                          overflow: "hidden",
                        }}
                      >
                        <Tooltip
                          title={testCase?.manual_test_case_id}
                          placement="top"
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              ...componentStyle.font.tableText,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Box component="span" fontWeight="bold">
                              ID:
                            </Box>{" "}
                            {testCase?.manual_test_case_id ?? "-"}
                          </Typography>
                        </Tooltip>

                        <Tooltip title={testCase?.name} placement="top">
                          <Typography
                            variant="body2"
                            sx={{
                              ...componentStyle.font.tableText,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Box component="span" fontWeight="bold">
                              Name:
                            </Box>{" "}
                            {testCase?.name ?? "-"}
                          </Typography>
                        </Tooltip>

                        <Tooltip title={testCase?.description} placement="top">
                          <Typography
                            variant="body2"
                            sx={{
                              ...componentStyle.font.tableText,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%", // ensures ellipsis
                            }}
                          >
                            <Box component="span" fontWeight="bold">
                              Description:
                            </Box>{" "}
                            {testCase?.description ?? "-"}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        );
      },
    },

    {
      field: "users",
      headerName: "Assignee",
      headerAlign: "center",
      width: 180,
      renderCell: (params) => {
        const techServiceUsers = params?.row?.tech_service_users || [];

        const oemUsers = params?.row?.oem_users || [];
        const supplierUsers = params?.row?.suppliers || [];
        const createdBy = params?.row?.created_by || "";
        const defaultUserDetails = {
          fullname: "User removed",
          email: "",
          role_details: {},
        };

        const allUserIds = [...techServiceUsers, ...oemUsers, ...supplierUsers];

        const techServiceUserOptions = techServiceUsers?.map((userId) => ({
          id: userId,
          ...(userDetailsMap?.get(userId) || defaultUserDetails),
        }));

        const oemUserOptions = oemUsers?.map((userId) => ({
          id: userId,
          ...(userDetailsMap?.get(userId) || defaultUserDetails),
        }));

        const supplierUserOptions = supplierUsers?.map((userId) => ({
          id: userId,
          ...(userDetailsMap?.get(userId) || defaultUserDetails),
        }));

        const techServiceDefault =
          techServiceUserOptions?.length > 0
            ? techServiceUserOptions[0]?.id
            : "";
        const oemDefault =
          oemUserOptions?.length > 0 ? oemUserOptions[0]?.id : "";

        const supplierDefault =
          supplierUserOptions?.length > 0 ? supplierUserOptions[0]?.id : "";

        return (
          <>
            <FormControl
              // fullWidth
              sx={{ ...componentStyle.form.select.formControl, width: "160px" }}
            >
              {techServiceUserOptions?.length > 0 && (
                <>
                  <label style={{ ...componentStyle.form.select.label }}>
                    Select Compliance Reviewers
                  </label>
                  <Select
                    value={techServiceDefault}
                    displayEmpty
                    sx={{ ...componentStyle.form.select.select }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          width: "160px",
                        },
                        sx: { maxHeight: 300 },
                      },
                    }}
                    renderValue={(selected) => {
                      const selectedUser = techServiceUserOptions?.find(
                        (user) => user?.id === selected,
                      );
                      return selectedUser
                        ? selectedUser?.fullname
                        : "No Compliance reviewers";
                    }}
                  >
                    {techServiceUserOptions?.map((user) => (
                      <MenuItem
                        sx={{
                          ...componentStyle.form.select.menuItem,
                          "&:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },

                          // Selected
                          "&.Mui-selected": {
                            backgroundColor: "#ebebeb !important",
                          },

                          // Selected + Hover
                          "&.Mui-selected:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },
                        }}
                        key={`tech-${user?.id}`}
                        value={user?.id}
                      >
                        <Box
                          sx={{
                            p: 0,
                            m: 0,
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          {user?.fullname}
                          <br />
                          {user?.email}
                          <br />
                          {user?.role_details?.role_name}
                          <br />
                          {user?.role_details?.department}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}

              {oemUserOptions?.length > 0 && (
                <>
                  <label
                    style={{
                      ...componentStyle.form.select.label,
                      marginTop:
                        techServiceUserOptions?.length > 0 ? "10px" : "0",
                    }}
                  >
                    Select Compliance Requestors
                  </label>
                  <Select
                    value={oemDefault}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          width: "160px",
                        },
                        sx: { maxHeight: 300 },
                      },
                    }}
                    displayEmpty
                    sx={{
                      // height: "40px",
                      // fontSize: "15px",
                      // borderRadius: "0px",
                      ...componentStyle.form.select.select,
                    }}
                    renderValue={(selected) => {
                      const selectedUser = oemUserOptions?.find(
                        (user) => user?.id === selected,
                      );
                      return selectedUser
                        ? selectedUser?.fullname
                        : "No TA requestors";
                    }}
                  >
                    {oemUserOptions?.map((user) => (
                      <MenuItem
                        sx={{
                          ...componentStyle.form.select.menuItem,
                          "&:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },

                          // Selected
                          "&.Mui-selected": {
                            backgroundColor: "#ebebeb !important",
                          },

                          // Selected + Hover
                          "&.Mui-selected:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },
                        }}
                        key={`oem-${user?.id}`}
                        value={user?.id}
                      >
                        {user?.fullname}
                        <br />
                        {user?.email}
                        <br />
                        {user?.role_details?.role_name}
                        <br />
                        {user?.role_details?.department}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}

              {supplierUserOptions?.length > 0 && (
                <>
                  <label
                    style={{
                      ...componentStyle.form.select.label,
                      marginTop: supplierUserOptions?.length > 0 ? "10px" : "0",
                    }}
                  >
                    Suppliers
                  </label>
                  <Select
                    value={supplierDefault}
                    displayEmpty
                    sx={{
                      // height: "40px",
                      // fontSize: "15px",
                      // borderRadius: "0px",
                      ...componentStyle.form.select.select,
                    }}
                    renderValue={(selected) => {
                      const selectedUser = supplierUserOptions?.find(
                        (user) => user?.id === selected,
                      );
                      return selectedUser
                        ? selectedUser?.fullname
                        : "No Suppliers";
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          width: "160px",
                        },
                        sx: { maxHeight: 300 },
                      },
                    }}
                  >
                    {supplierUserOptions?.map((user) => (
                      <MenuItem
                        sx={{
                          ...componentStyle.form.select.menuItem,
                          "&:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },

                          // Selected
                          "&.Mui-selected": {
                            backgroundColor: "#ebebeb !important",
                          },

                          // Selected + Hover
                          "&.Mui-selected:hover": {
                            backgroundColor: "#e0e0e0 !important",
                          },
                        }}
                        key={`sup-${user?.id}`}
                        value={user?.id}
                      >
                        {user?.fullname}
                        <br />
                        {user?.email}
                        <br />
                        {user?.role_details?.role_name}
                        <br />
                        {user?.role_details?.department}
                      </MenuItem>
                    ))}
                  </Select>
                </>
              )}

              {techServiceUserOptions?.length === 0 &&
                oemUserOptions?.length === 0 &&
                supplierUserOptions?.length === 0 && (
                  <Typography sx={componentStyle.font.tableText}>
                    No Users Available
                  </Typography>
                )}
            </FormControl>
          </>
        );
      },
    },

    {
      field: "updated_at",
      headerName: "Changed At",
      headerAlign: "center",
      width: 100,
      renderCell: (params) => (
        <Box sx={{ textAlign: "center", ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      headerAlign: "center",
      width: 100,
      renderCell: (params) => (
        <Box sx={{ textAlign: "center", ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
  ];

  useEffect(() => {
    if (ticketDetails) {
      const filteredTicketList = ticketDetails
        ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        ?.map((item, index) => ({
          ...item,
          id: (page - 1) * rowsPerPage + index + 1,
          intr_id: item?.intr_id,
          tech_service_users: item?.tech_service_users,
          oem_users: item?.oem_users,
          users: item?.tech_service_users || item?.oem_users,
          ticket_id: item?.ticket_id,
          tickets_type: item?.tickets_type,
          ticket_type: item?.ticket_type,
          status: item?.status,
          ticket_status: item?.ticket_id || item?.status,
          ls_details: item?.ls_details,
          lr_details: item?.lr_details,
          swm_details: item?.swm_details,
          vehicle_system_details: item?.vehicle_system_details,
          vehicle_component_details: item?.vehicle_component_details,
          ee_details: item?.ee_details,
          description: item?.description,
          created_at: ConvertUTCToDate(
            item?.created_at,
            profileDetails?.profile?.profile?.region,
          ),
          created_by: item?.created_by,
          updated_at: ConvertUTCToDate(
            item?.updated_at,
            profileDetails?.profile?.profile?.region,
          ),
          updated_by: item?.updated_by,
          allData: item,
        }));

      setTableRowsData(filteredTicketList);
    }
  }, [ticketDetails]);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <Box sx={{ height: "450px", width: "100%" }}>
      <CustomDataGridV2
        rows={tableRowsData}
        columns={COLUMNS}
        rowCount={tableRowsData?.length}
        isMultiLine={true}
        showPagination={false}
        enableMore={hasTicketNeedMore}
        handleMore={(data) => {
          const getTicketType = () => {
            switch (Number(tickets_type)) {
              case TICKETS_TYPES.EE:
                return 0;
              case TICKETS_TYPES.SWM:
                return 1;
              case TICKETS_TYPES.VEHICLE_SYSTEM:
                return 2;
              case TICKETS_TYPES.VEHICLE_COMPONENT:
                return 3;
              default:
                return 0;
            }
          };
          let ticketType = getTicketType();

          navigate(
            `/dashboard/v2/type-approval/tickets?tab=${Number(ticketType) || 0}`,
          );
        }}
      />
      <ModuleViewMoreDialog
        isEEDialogOpen={isEEDialogOpen}
        toggleEEDialog={toggleEEDialog}
        selectedComponent={selectedComponent}
        linkApiProps={linkApiProps}
        apiAction={apiAction}
        apiDataKey={apiDataKey}
        type={moduleViewMoreType}
      />
      {/* Legal Dialoug */}
      <CustomDialogBoxV2
        open={isLegalDialogOpen}
        onClose={toggleLegalDialog(false)}
        title={
          <Box
            sx={{
              fontWeight: "bold",
              color: "black",
              fontSize: "15px",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              flex: 1,
            }}
          >
            Legal Details
          </Box>
        }
      >
        <Box sx={{ width: "650px" }}>
          {/* Legal Standards */}
          <Box>
            {legalDialogData?.items3 && (
              <Box>
                {legalDialogData?.items3?.map((ls, index) => (
                  <Box
                    sx={{
                      // border: "1px solid black",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "15px",
                      }}
                    >
                      Legal Standard
                    </Typography>
                    <Box sx={{ gap: "10px" }}>
                      {[
                        { header: "ID", value: ls?.ls_id },
                        {
                          header: "Standard Number",
                          value: ls?.standard_number,
                        },
                        { header: "Name", value: ls?.name },
                        { header: "Revision", value: ls?.revision },
                        { header: "Description", value: ls?.description },
                        {
                          header: "Chapters",
                          value: ls?.chapters.join(", "),
                        }, // Display chapters
                      ]?.map((det, key) => (
                        <Typography key={key} sx={{ fontSize: "14px" }}>
                          {det?.header}: {det?.value}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
          {/* Legal Requirements */}
          <Box>
            {legalDialogData?.heading2 && (
              <Box>
                {legalDialogData?.items2?.map((lr, index) => (
                  <Box
                    sx={{
                      // border: "1px solid black",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "15px",
                      }}
                    >
                      Legal Requirements
                    </Typography>
                    <Box sx={{ gap: "10px" }}>
                      {[
                        { header: "ID", value: lr?.lr_id },
                        { header: "Chapter", value: lr?.chapter },
                        {
                          header: "Requirement Number",
                          value: lr?.req_number,
                        },
                        {
                          header: "Description",
                          value: lr?.description,
                        },
                      ]?.map((det, key) => (
                        <Typography key={key} sx={{ fontSize: "14px" }}>
                          {det?.header}: {det?.value}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </CustomDialogBoxV2>
    </Box>
  );
}

export default RecentTickets;
